






import { Vue, Watch, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import store from '@/store';
import { IProject, IMarkers } from '@/interfaces/data';
import {
  COPY_MARKERS_TO_TEMPMARKERS,
  SET_FILTERING_ELEMENT_DISABLED,
  CHANGE_RADIO_GROUP_TEXT,
  CHANGE_SLIDER_MODEL_VALUE,
  SET_FILTERING_STATE_TO_DEFAULT,
  SET_OVERLAY_DISPLAY
} from '@/store/constants/mutation-types';

@Component
export default class UserTreeView extends Vue {
  public $auth!: {
    token: string;
    isAuthenticated: boolean;
    isAdmin: boolean;
    loading: boolean;
  };

  private treeViewItems = [];
  private treeViewModel = [];

  @(namespace('OverLayModule').State('overlayEnable'))
  private overlayEnable;

  private treeViewCount = 0;
  private sliderModel = 0;

  @(namespace('ProjectModule').State('projects')) private projects!: IProject[];

  @(namespace('LocationModule').Action('requestAllLocationsForProject'))
  private requestAllLocationsForProject!: ({ token, projectId }) => Promise<{}>;

  @(namespace('LocationModule').State('markers')) private markers!: IMarkers[];

  @(namespace('LocationModule').State('tempMarkers'))
  private tempMarkers!: IMarkers[];

  @(namespace('LocationModule').Mutation(COPY_MARKERS_TO_TEMPMARKERS))
  private copyMarkersTotempMarkers!: () => void;

  @(namespace('LocationModule').Mutation('removeMarkerFromtempMarkers'))
  private removeMarkerFromtempMarkers!: (markers) => void;

  // name deleteMarkers
  @(namespace('LocationModule').Mutation('deleteLocation'))
  private deleteLocation!: (projectId) => [];

  @(namespace('MarkersFilteringModule').State('radioGroup'))
  private radioGroup;

  @(namespace('MarkersFilteringModule').State('filterElementDisabled'))
  private filterElementDisabled;

  private oldTreeViewModel = [];

  private async created() {
    await store.dispatch('ProjectModule/getProjects', this.$auth.token);
    this.projects.map(project => {
      const treeViewItem = {
        id: project.id,
        name: project.name
      };
      this.treeViewItems.push(treeViewItem);
    });
  }

  @Watch('treeViewModel')
  private onPropertyChanged() {
    store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, true);
    // when the treeview checkbox is checked
    if (!this.treeViewCount || this.treeViewCount < this.treeViewModel.length) {
      const projectId = this.treeViewModel.slice(-1)[0];
      const token = this.$auth.token;
      this.requestAllLocationsForProject({
        token,
        projectId
      })
        .then(data => {
          // make copyOriginalMarkers method
          this.copyMarkersTotempMarkers();
          store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
          if (this.tempMarkers.length > 0) {
            store.commit(
              `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
              false
            );
            store.commit(
              `MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`,
              'all'
            );
          }
        })
        .catch(err => console.log(err));

      this.treeViewCount = this.treeViewModel.length;
      this.oldTreeViewModel = this.treeViewModel.slice();
    }
    // when the treeview checkbox is unchecked
    else if (this.treeViewCount > this.treeViewModel.length) {
      const projectId = this.oldTreeViewModel.filter(
        item => !this.treeViewModel.includes(item)
      );
      this.deleteLocation(projectId[0]);
      this.removeMarkerFromtempMarkers(projectId[0]);
      // difference between old tree view model and current
      this.oldTreeViewModel = this.treeViewModel.slice();
      store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
      if (this.treeViewModel.length === 0) {
        store.commit(
          `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
          true
        );
      }
     
      this.treeViewCount = this.treeViewModel.length;
    }
    store.commit(`MarkersFilteringModule/${CHANGE_SLIDER_MODEL_VALUE}`, 0);
    store.commit(`MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`, '');
  }
}
